import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { PaywallGate, type PaywallGateProps } from '../PaywallGate';
import { useConversionGate, type UseConversionGateArgs } from './useConversionGate';
export type ConversionGateProps = UseConversionGateArgs & Pick<PaywallGateProps, 'assurance' | 'compactCta' | 'ctaLabel' | 'ctaProps' | 'density' | 'headline' | 'meter' | 'onDismiss'> & {
  children?: ReactNode;
};

/**
 * Production gate: `PaywallGate` wired to the viewer, the live catalog, and the Conversion
 * checkout. The plan named on the wall is the plan the checkout sells.
 */
export const ConversionGate = t0 => {
  const $ = _c(29);
  let assurance;
  let children;
  let compactCta;
  let ctaLabel;
  let ctaProps;
  let density;
  let gateArgs;
  let headline;
  let meter;
  let onDismiss;
  if ($[0] !== t0) {
    ({
      assurance,
      children,
      compactCta,
      ctaLabel,
      ctaProps,
      density,
      headline,
      meter,
      onDismiss,
      ...gateArgs
    } = t0);
    $[0] = t0;
    $[1] = assurance;
    $[2] = children;
    $[3] = compactCta;
    $[4] = ctaLabel;
    $[5] = ctaProps;
    $[6] = density;
    $[7] = gateArgs;
    $[8] = headline;
    $[9] = meter;
    $[10] = onDismiss;
  } else {
    assurance = $[1];
    children = $[2];
    compactCta = $[3];
    ctaLabel = $[4];
    ctaProps = $[5];
    density = $[6];
    gateArgs = $[7];
    headline = $[8];
    meter = $[9];
    onDismiss = $[10];
  }
  const gate = useConversionGate(gateArgs);
  let t1;
  if ($[11] !== assurance || $[12] !== children || $[13] !== compactCta || $[14] !== ctaLabel || $[15] !== ctaProps || $[16] !== density || $[17] !== gate.intent || $[18] !== gate.loading || $[19] !== gate.onContinue || $[20] !== gate.onJoin || $[21] !== gate.onLogin || $[22] !== gate.product || $[23] !== gate.state || $[24] !== gate.tokens || $[25] !== headline || $[26] !== meter || $[27] !== onDismiss) {
    t1 = <PaywallGate assurance={assurance} compactCta={compactCta} ctaLabel={ctaLabel} ctaProps={ctaProps} density={density} headline={headline} intent={gate.intent} loading={gate.loading} meter={meter} product={gate.product} state={gate.state} tokens={gate.tokens} onContinue={gate.onContinue} onDismiss={onDismiss} onJoin={gate.onJoin} onLogin={gate.onLogin}>{children}</PaywallGate>;
    $[11] = assurance;
    $[12] = children;
    $[13] = compactCta;
    $[14] = ctaLabel;
    $[15] = ctaProps;
    $[16] = density;
    $[17] = gate.intent;
    $[18] = gate.loading;
    $[19] = gate.onContinue;
    $[20] = gate.onJoin;
    $[21] = gate.onLogin;
    $[22] = gate.product;
    $[23] = gate.state;
    $[24] = gate.tokens;
    $[25] = headline;
    $[26] = meter;
    $[27] = onDismiss;
    $[28] = t1;
  } else {
    t1 = $[28];
  }
  return t1;
};